<div class="login-container">
  <div class="login-content">
    <img src="../../../assets/images/afs-logo.png" alt="Logo" class="login-logo" />
    <p class="login-textmain">Login your account.</p>
    <p class="login-textsub">Enter your login details below to access your account.</p>
    <form class="new-form top-margin-30" (ngSubmit)="onSubmit()">
      <div class="form-group">
        <mat-form-field style="width:100%" appearance="outline">
          <mat-label>Enter Email / Username : </mat-label>
          <input matInput type="email" name="username" [(ngModel)]="LoginData.username" required>
          <mat-error *ngIf="LoginData.username!==null">Username is required</mat-error>
        </mat-form-field>
      </div>

      <div class="form-group">
        <mat-form-field style="width:100%" appearance="outline">
          <mat-label>Password</mat-label>
          <input matInput [type]="hide ? 'password' : 'text'" name="password" [(ngModel)]="LoginData.password" required>
          <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'"
            [attr.aria-pressed]="hide">
            <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
          </button>
          <mat-error *ngIf="LoginData.password!==null">Password is required</mat-error>
        </mat-form-field>
      </div>
      
      <button type="submit" class="login-btn">Login <i class="fa fa-long-arrow-right left-margin-10"> </i></button>
      <a href="" class="textLink" [routerLink]="'/forgetPassword'">Forgot Password ?</a>
      <div class="clearfix"></div>
    </form>
  </div>
  <div class="copyright-login"> © 2022 AFS Group. All rights reserved.</div>
</div>